<template>
  <div class="projectContainer">
    <div class="project-container-left">
      <div class="editCube">
        <EditBtn class="topRight" @click="edit='base1'" v-if="edit!=='base1'"/>
        <div class="fieldTitle">合作資訊設定</div>
        <div class="fields" v-if="projectName">
          <div class="field">
            <div>專案開關</div>
            <RT :options="['開放中', '已關閉']" :defaultValue="actived ? '開放中' : '已關閉'" @input="actived=$event==='開放中'" :disabled="edit!=='base1'"/>
          </div>
          <div class="field">
            <div>適用商店</div>
            <Select1 :width="'300px'" :defaultValue="store" @input="store=$event" :disabled="edit!=='base1'">
              <option :value="null">請選擇商店</option>
              <option v-for="rest in restaurants" :key="`rest-${rest}`" :value="rest">{{rest}}</option>
            </Select1>
          </div>
          <div class="field">
            <div>合作代理</div>
            <div class="user-box" @click="uldisplay=edit==='base1'&&true">
              <div v-if="partner">{{partner?.name}} <button class="removebtn" @click="partner=null"></button></div>
              <div v-else class="placeholder">請選擇合作代理</div>
            </div>
          </div>
          <div class="field">
            <div>專案名稱</div>
            <input type="text" :disabled="edit!=='base1'" v-model.trim="projectName">
          </div>
          <div class="field">
            <div>專案ID</div>
            <div>
              <input type="text" :disabled="edit!=='base1'" v-model.trim="projectId">
              <div class="errorRange" v-if="errorId" v-html="errorId"></div>
            </div>
          </div>
          <div class="field">
            <div>日期模式</div>
            <RT :options="['區間', '列表']" :defaultValue="useRange ? '區間' : '列表'"
            @input="updateUseRange" :disabled="edit!=='base1'"/>
          </div>
          <template  v-if="edit!=='base1'">
            <div class="field start" v-if="!useRange">
              <div>指定日期</div>
              <div class="dates"><div class="date" v-for="date in projectDates" :key="date">{{moment(date).format(moment(date).year() === y ? 'MM/DD' : 'YYYY/MM/DD')}}</div></div>
            </div>
            <div class="field" v-else>
              <div>專案區間</div>
              <div>{{toDate(projectRange.start)}}~{{toDate(projectRange.end)}}</div>
            </div>
          </template>
          <template v-else>
          <div class="field" v-if="!useRange">
            <div>指定日期</div>
            <div class="dates">
              <div class="date" v-for="date in projectDates" :key="date">{{moment(date).format(moment(date).year() === y ? 'MM/DD' : 'YYYY/MM/DD')}}</div>
              <button class="dateAdd" @click="selectDates=true" :disabled="useRange">增加</button>
            </div>
          </div>
            <div class="field" v-else>
              <div>專案區間</div>
              <rangeInput :style="{margin: 0, width: '460px'}" :disabled="!useRange" :size="'sm'" :defaultValue="projectRange" @input="projectRange=$event" @range="range=$event"/>
            </div>
          </template>
          <div class="field">
            <div>開放預約</div>
            <div>
              <rangeInput :style="{margin: 0, width: '460px'}" :disabled="(edit!=='base1' || (useRange && (!projectRange.start||!projectRange.end)) || (!useRange && projectDates.length === 0))" :size="'sm'" :defaultValue="bookableRange" @input="bookableRange=$event"/>
              <div class="errorRange" v-if="errorRange" v-html="errorRange"></div>
            </div>
          </div>
          <div class="field">
            <div>接洽人員</div>
            <Select1 :width="'300px'" :defaultValue="salesman" @input="salesman=$event" :disabled="edit!=='base1'">
              <option :value="null">請選擇接洽人員</option>
              <option v-for="(sm, s) in salesmans" :key="`salesman-${s}`" :value="sm._id">{{sm.name}}</option>
            </Select1>
          </div>
          <div class="field">
            <div>備註</div>
            <textarea v-model="remark" :disabled="edit!=='base1'"></textarea>
          </div>
          <BtnsS v-if="edit==='base1'" :style="{marginLeft: 'auto'}"
          @cancel="setEdit();edit=null" @save="save"/>
        </div>
      </div>
      <div :style="{marginTop: 'auto'}">
        <button class="deleteBtn" @click="deleteProject=true" :style="{marginTop: 'auto'}">刪除專案</button>
      </div>
    <DialogDef2 :show="uldisplay" v-if="uldisplay" @close="uldisplay=false" label="請選擇合作代理">
      <div class="selectPartner">
        <input type="text" id="user-input" v-model="userText" >
        <div class="ul">
          <div class="li" v-for="(ag, j) in partners" :key="`agency-${j}`"
          @click="setPartner(ag)">
          <div>{{ag.taxID || '------------'}}</div>
          <div :style="{borderLeft: '1px solid', paddingLeft: '10px'}">{{ag.name}}</div></div>
        </div>
      </div>
    </DialogDef2>
    <DialogDef2 :show="selectDates" v-if="selectDates" @close="selectDates=false" label="請選擇可預約日期">
      <dateSelector :dates="projectDates" @input="updateSelectDates"/>
    </DialogDef2>
    <DialogDef2 label="刪除專案" show="deleteProject" v-if="deleteProject">
      <div class="deleteProject">
        <div class="large">確定要刪除此專案嗎?</div>
        <div>專案ID: {{project.projectId}}</div>
        <div>專案名稱: {{project.projectName}}</div>
        <BtnsS :save="'確定'" :style="{marginTop: '20px'}" @cancel="deleteProject=false" @save="deleteProjectFn"/>
      </div>
    </DialogDef2>
    </div>
    <div>
      <div class="fieldTitle">專案連結 <RoundBtn @click="addTag=true" :style="{marginLeft: '90px'}" :icon="'add'" :bg="'var(--color-pri)'" :text="'新增'"/></div>
      <div class="links" :style="{marginTop:'20px'}">
        <div v-for="k in project.tags.map(e => e.key)" :key="k">
          <div>{{tags[k]}}</div>
          <div @click="copylink(k)" class="copy"></div>
        </div>
      </div>
      <DialogDef2 :show="addTag" v-if="addTag" @close="addTag=false" label="新增連結">
        <div class="addTag">
          <input type="text" v-model="tag" :placeholder="'請輸入連結標籤'">
          <BtnsS @cancel="addTag=false" @save="saveTag"/>
        </div>
      </DialogDef2>
      <div class="alarm" v-if="alertshow" :style="{height: 'fit-content!important'}">網址已複製!<br>{{alertshow}}</div>
      <div class="alarm error" v-if="LinkError" :style="{height: 'fit-content!important'}">{{LinkError}}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex/dist/vuex.common.js'
import EditBtn from '../../../components/btn/edit.vue'
import rangeInput from '../../../components/input/dateRange.vue'
import { deleteapi, getapi, postapi } from '../../../store/fetch'
import dateSelector from './dateSelector.vue'
import RoundBtn from '../../../components/btn/round.vue'
const { VUE_APP_LIFF } = process.env
export default {
  components: { rangeInput, EditBtn, dateSelector, RoundBtn },
  props: ['project', 'salesmans'],
  data () {
    return {
      VUE_APP_LIFF,
      edit: null,
      y: this.moment().year(),
      userText: null,
      uldisplay: false,
      partners: [],
      selectDates: false,
      // 編輯內容
      store: null,
      actived: false,
      projectName: null,
      projectId: null,
      salesman: null,
      remark: null,
      partner: null,
      projectDates: [],
      useRange: false,
      projectRange: { start: null, end: null },
      bookableRange: { start: null, end: null },
      // 複製連結用
      alertshow: null,
      Link: null,
      LinkError: null,
      // 新增連結用
      addTag: false,
      tag: null,
      // ERROR MESSAGE
      errorId: null,
      // 刪除專案
      deleteProject: false
    }
  },
  computed: {
    tags () {
      return Object.assign({}, ...this.project.tags.map(e => { return { [e.key]: e.name } }))
    },
    ...mapState({
      restaurants: 'restaurants'
    }),
    bookingStartTable () {
      try {
        const table = this.$store.getters.getStoreByKey(this.store, 'bookingStartTable')
        const normal = this.$store.getters.getStoreByKey(this.store, 'bookingStart')
        const time_table = this.moment().add(-1 * table.value, table.unit)
        const time_normal = this.moment().add(-1 * normal.value, normal.unit)
        if (time_table.isBefore(time_normal)) {
          return table
        } else {
          return normal
        }
      } catch (error) {
        return { value: 0, unit: 'day' }
      }
    },
    maxDate () {
      if (this.bookingStartTable && this.bookingStartTable.unit && ('value' in this.bookingStartTable)) {
        if (!this.useRange) {
          const dates = JSON.parse(JSON.stringify(this.projectDates))
          dates.sort((a, b) => this.moment(a).isAfter(this.moment(b)) ? 1 : -1)
          const max = dates.slice(-1)[0]
          console.log('[max]', max)
          return this.moment(max, 'YYYY-MM-DD').add(-1 * this.bookingStartTable.value, this.bookingStartTable.unit)
        } else {
          return this.moment(this.projectRange.end, 'YYYY-MM-DD').add(-1 * this.bookingStartTable.value, this.bookingStartTable.unit)
        }
      } else {
        return this.moment().add(-1 * this.bookingStartTable.value, this.bookingStartTable.unit)
      }
    },
    errorRange () {
      if (this.moment(this.bookableRange.end).isAfter(this.maxDate)) {
        return '開放日期請小於最後預約日<br>(請符合餐廳設定-預約日範圍限制)'
      } else {
        return null
      }
    }
  },
  mounted () {
    this.setEdit()
  },
  watch: {
    userText () {
      this.getpartners()
    },
    project: {
      immediate: true,
      handler () {
        this.setEdit()
      }
    },
    async projectId () {
      if (this.projectId) {
        this.errorId = await getapi(`projects/check/ID/${this.projectId}?id=${this.project._id}`)
      } else {
        this.errorId = null
      }
    }
  },
  methods: {
    async copylink (from) {
      const _type = this.$store.getters.getStoreType(this.store)
      const type = _type === 'restaurant' ? 'rest' : 'shop'
      const params = new URLSearchParams({
        q: this.project._id,
        s: from
      })
      const link = encodeURI(`${VUE_APP_LIFF}/${type}Start?${params}`)
      try {
        const x = await this.$copyText(link)
        if (x) {
          this.Link = '複製成功'
          this.alertshow = link
          setTimeout(() => {
            this.Link = null
          }, 2000)
          setTimeout(() => {
            this.alertshow = null
          }, 5000)
        }
      } catch (error) {
        this.LinkError = '複製失敗'
        setTimeout(() => {
          this.LinkError = null
        }, 2000)
      }
    },
    updateSelectDates (ev) {
      this.projectDates = ev
      this.selectDates = false
    },
    setEdit () {
      if (this.project) {
        this.actived = this.project.actived
        this.salesman = this.project.salesman || null
        this.remark = this.project.remark || null
        this.projectName = this.project.projectName
        this.projectId = this.project.projectId
        this.partner = this.project.partner || null
        this.projectDates = this.project.projectDates || []
        this.useRange = this.project.useRange
        this.store = this.project.store
        this.projectRange = {
          start: this.toDate(this.project.projectRange.start),
          end: this.toDate(this.project.projectRange.end)
        }
        this.bookableRange = {
          start: this.toDate(this.project.bookableRange.start),
          end: this.toDate(this.project.bookableRange.end)
        }
      }
    },
    async saveTag () {
      if (!this.tag) {
        return false
      }
      const body = {
        action: 'add',
        tag: this.tag
      }
      const r = await postapi(`projects/${this.project._id}/tag`, body)
      if (r) {
        this.$emit('refresh')
        this.edit = null
        this.addTag = false
      }
    },
    async deleteProjectFn () {
      const r = await deleteapi(`projects/${this.project._id}`)
      if (r) {
        this.$router.replace({ name: 'restProject' })
      }
    },
    async save () {
      if (this.errorRange) {
        return false
      }
      const body = {
        partner: this.partner,
        useRange: this.useRange,
        projectName: this.projectName,
        projectId: this.projectId,
        actived: this.actived,
        projectDates: this.projectDates,
        projectRange: this.projectRange,
        bookableRange: this.bookableRange,
        store: this.store,
        remark: this.remark,
        salesman: this.salesman
      }
      const r = await postapi(`projects/${this.project._id}/base`, body)
      if (r) {
        this.$emit('refresh')
        this.edit = null
      }
    },
    removePartner () {
      console.log('removePartner')
      this.partner = null
      this.userText = null
      this.partners = []
      this.$nextTick(() => {
        console.log('[next]')
      })
    },
    setPartner (ag) {
      this.partner = JSON.parse(JSON.stringify(ag))
      this.uldisplay = false
    },
    updateUseRange (event) {
      const bool = event === '區間'
      if (bool) {
        this.useRange = true
      } else {
        this.useRange = false
      }
    },
    async getpartners () {
      const partners = await getapi('partners?scope[]=name&scope[]=taxID&' + new URLSearchParams({ search: this.userText }))
      this.partners = partners.data
      this.uldisplay = true
    }
  }
}
</script>
<style lang="scss">
.projectContainer .field {
 .date-time-picker, .field-input {
  height: 40px!important;
  min-height: 40px!important;
 }
}

</style>
<style lang="scss" scoped>
.project-container-left {
  height: 100%;
  display: flex;
  flex-direction: column;
  .deleteBtn {
    height: 60px;
    width: 100%;
    font-size: 22px;
    background-color: var(--highlight);
    color: #FFFFFF;
    letter-spacing: .1em;
    border-radius: 3px;
  }
}
.deleteProject {
  margin-inline: auto;
  width: fit-content;
  padding: 40px;
  height: fit-content;
  font-size: 22px;
  gap: 20px;
  display: flex;
  flex-direction: column;
  text-align: start;
  .large {
    font-size: 28px;
  }
}
.addTag {
  height: 200px;
  padding: 40px 40px 20px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  input[type=text] {
    height: 70px;
    border: 1px solid #CACACA;
    width: 100%;
    font-size: 28px;
    text-align: center;

  }
}
.alarm {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background-color: var(--color-infobox);
  color: var(--color-pri);
  height: 3em;
  border-radius: 3px;
  font-size: 20px;
  text-align: start;
  border: none;
  padding: 10px 20px;
  box-shadow: 0px 4px 10px 0px #00000040;
  &.error {
    background-color: var(--highlight);
  }
}
.copy {
  width: 40px;
  height: 40px;
  background-color: #CACACA;
  mask-image: url(/svg/btn/copy.svg);
  mask-size: 30px;
  mask-position: center;
  mask-repeat: no-repeat;
  margin-left: auto;
  &:hover {
    background-color: #5E5E5E;
  }

}
.links {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  &>div {
    height: 60px;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 260px;
  }
}
.removebtn {
  margin-left: auto;
  height: 40px;
  background-color: #CACACA;
  width: 23px;
  mask-image: url(/svg/btn/close.svg);
  mask-size: 15px;
  mask-repeat: no-repeat;
  mask-position: center;
  border: none;
  outline: 1px solid #CACACA;
  box-sizing: content-box;
  padding: 0;
}
.placeholder {
  color: #C4C4C4;

}
.selectPartner {
  width: 600px;
  height: 400px;
  padding: 20px;
  display: grid;
  grid-template-rows: 45px 1fr;
  gap: 15px;
}
#user-input {
  width: 100%;
  border: 1px solid #CACACA;
  padding-inline: 1em;
  border-radius: 3px;
  font-size: 20px;
  letter-spacing: .1em;
  height: 45px;
}
.user-box {
  width: 295px;
  text-align: start;
  padding-inline: 1em;
  border: 1px solid #B8B8B8;
  border-radius: 5px;
  height: 40px;
  display: flex;
  align-items: center;
  &>div{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
}
.ul {
  width: 100%;
  background-color: #FFFFFF;
  max-height: 230px;
  overflow-y: auto;
  z-index: 99;
  .li {
    border-bottom: 1px solid #CACACA;
    padding-block: 7.25px;
    padding-inline: .75em;
    min-height: 55px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    line-height: 40px;
    text-align: start;
    &:hover {
      background-color: #CACACA;
    }
  }
}
.editCube {
  position: relative;
  width: 600px;
  .topRight {
    position: absolute;
    top: 0;
    right: 0;
  }
}
.date {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-pri);
  color: var(--color-pri);
  padding: 3px 6px;
  border-radius: 3px;
  height: 40px;
}
.dateAdd {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-pri);
  background-color: var(--color-pri);
  color: #FFFFFF;
  padding: 3px 6px;
  border-radius: 3px;
  gap: 5px;
  line-height: 20px;
  height: 40px;
  &::before{
    content: '';
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #FFFFFF;
    mask-image: url(/svg/btn/add.svg);
    width: 20px;
    height: 20px;
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
  }

}
.dates {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  flex-wrap: wrap;
}
.projectContainer {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  height: calc(100vh - 90px);
  overflow-y: hidden;
  &>div{
    height: calc(100vh - 90px);
    max-height: calc(100vh - 90px);
    overflow-y: auto;
    padding: 25px 49px;
  }
  &>:not(:last-child) {
    border-right: 1px solid #CACACA;
  }
}
.fields {
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 25px;
}
.field {
  display: grid;
  grid-template-columns: 5em 1fr;
  text-align: start;
  gap: 15px;
  position: relative;
  &>:nth-child(1) {
    color: #5E5E5E;
    font-weight: 400;
    font-size: 20px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 40px;
  }
  &>:nth-child(2) {
    font-weight: 400;
    font-size: 18px;
    letter-spacing: .05em;
    .errorRange {
      top: 50px;
      color: var(--highlight);
      text-align: start;
    }
  }
  textarea {
    width: 100%;
    height: 120px;
    border: 1px solid #CACACA;
    border-radius: 3px;
    padding: .5em 1em;
  }
  input[type=text] {
    height: 40px;
    border-radius: 3px;
    border: 1px solid #C4C4C4;
    padding-inline: .8em;
    font-weight: 400;
    font-size: 18px;
    letter-spacing: .1em;
    max-width: 461px;

  }
}
.fieldTitle {
  font-weight: 500;
  font-size: 25px;
  color: var(--color-checked);
  text-align: start;
  letter-spacing: .1em;
  vertical-align: middle;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
